import { render, staticRenderFns } from "./ProductEmbeddable.vue?vue&type=template&id=7ddffdb7&"
import script from "./ProductEmbeddable.vue?vue&type=script&lang=js&"
export * from "./ProductEmbeddable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports